import { render } from "./HospitalsManual.vue?vue&type=template&id=d8dc95a6&scoped=true"
import script from "./HospitalsManual.vue?vue&type=script&lang=js"
export * from "./HospitalsManual.vue?vue&type=script&lang=js"

import "./HospitalsManual.vue?vue&type=style&index=0&id=d8dc95a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8dc95a6"]])

export default __exports__